const DEFAULT_CONFIG = {
  app_logo_img: require('@/assets/logos/geoxymity-logo-text-icon.svg'),
  background_img: '',
  client_logo_img: '',
  background_text_color: '#ffcd03',
  title: ''
}

export const state = {
  config: DEFAULT_CONFIG,
  backLink: '',
  billingNotification: false
}
